/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Qr_Pick_EmptyInputs */

const vi_grower_area_qr_pick_empty = /** @type {(inputs: Grower_Area_Qr_Pick_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hộ này chưa khai vùng trồng nào.`)
};

/**

* @param {Grower_Area_Qr_Pick_EmptyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_qr_pick_empty = /** @type {((inputs?: Grower_Area_Qr_Pick_EmptyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Qr_Pick_EmptyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_qr_pick_empty(inputs)
});